import { inject, InjectionToken } from '@angular/core';
import { CONTACT_DETAIL_SIGNAL_STORE } from '../signal-store/contact.signal-store';
import { ContactSignalState } from '@data-access/profiles/types';

const CONTACT_DETAIL_TOKEN = new InjectionToken<ContactSignalState>(
  'Contact Detail',
);

export function contactDetailTokenizer() {
  return inject(CONTACT_DETAIL_TOKEN);
}

export const CONTACT_DETAIL_PROVIDER = {
  provide: CONTACT_DETAIL_TOKEN,
  useClass: CONTACT_DETAIL_SIGNAL_STORE,
};

